/**
 * Tab Component
 *
 * @file tab.js
 */

import $ from "jquery";
// import gsap from "gsap";

// get other plugins:
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);



const scrollAnimation = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab2 = () => {
    if($("#homeVideo").is(":visible")){
      $("#homeVideo")[0].play();
    }
    if($("#number-counter").is(":visible")){

      var a = 0;

      function countUp() {
        var num = $(this).text();
        var decimal = 0;
        if (num.indexOf(".") > 0) { // if number is Decimal
          decimal = num.toString().split(".")[1].length;
        }
        $(this)
          .prop("Counter", 0.0)
          .animate(
            {
              Counter: $(this).text()
            },
            {
              duration: 3000,
              easing: "swing",
              step: function (now) {
                $(this).text(parseFloat(now).toFixed(decimal));
              }
            }
          );
      }
      $(window).scroll(function() {
      
        var oTop = $('#number-counter').offset().top - window.innerHeight;
        if (a == 0 && $(window).scrollTop() > oTop) {
          $(".counter-value").each(countUp);
          a = 1;
        }
      
      });
      $(".counter-value-services").each(countUp);
    }
    //number counter//


    if($(".services-container").is(":visible")){
      $(document.body).addClass("hidden-x");
    }

    const scrollContainer = document.querySelector(".services-container");
    let halfWindowWidth = $(window).width() / 2;
    let temp = 0;

    function scrollAddClass(divName, divclassName) {
      let windowScrollPos = $(".section-scrolling").scrollLeft();
      // console.log(windowScrollPos);
      $(divName).each(function(){
        if(halfWindowWidth >= $(this).offset().left){
          $(this).addClass(divclassName);
        } else{
          $(this).removeClass(divclassName);
        }
      });
    }

    function scrollVideo(divName, divclassName) {
      let windowScrollPos = $(".section-scrolling").scrollLeft();
      // console.log(windowScrollPos);
      $(divName).each(function(){
        if(halfWindowWidth >= $(this).offset().left){
          $(this).addClass(divclassName);
          const vid = document.querySelectorAll(divName);
          for (var i = 0; i < $(divName).length; i++) {
            const j = i; // Create local copy
            vid[j].autoplay = "autoplay";
            vid[j].muted = true;  
            vid[j].play();
          }
        } else{
          $(this).removeClass(divclassName);
          const vid = document.querySelectorAll(divName);
          for (var i = 0; i < $(divName).length; i++) {
            const j = i; // Create local copy
            vid[j].autoplay = "false";
            vid[j].currentTime = 0;
            vid[j].pause();
          }
        }
      });
    }

    function scrollLeftPos(divName, xLeftPosDeg) {
      // console.log(windowScrollPos);
      $(divName).each(function(){

        if(halfWindowWidth >= $(this).offset().left){
          if ((halfWindowWidth - $(this).offset().left) <= xLeftPosDeg ) {
            $(this).css("margin-left", halfWindowWidth - $(this).offset().left + 'px');
          } else{
            $(this).css("margin-left", xLeftPosDeg +"px");
          }
        }
      });
    }

    function scrollLeftNegativePos(divName, xNegPosDeg) {
      // console.log(windowScrollPos);
      $(divName).each(function(){

        if(halfWindowWidth >= $(this).offset().left){
          if ((halfWindowWidth - $(this).offset().left) <= xNegPosDeg ) {
            $(this).css("margin-left", "-" + halfWindowWidth - $(this).offset().left + 'px');
          } else{
            $(this).css("margin-left", "-" + xNegPosDeg+"px");
          }
        }
      });
    }

    function scrollRightPos(divName, xRightPosDeg) {
      // console.log(windowScrollPos);
      $(divName).each(function(){

        if((halfWindowWidth + 200) >= $(this).offset().left){
          if ((halfWindowWidth - $(this).offset().left) <= xRightPosDeg ) {
            $(this).css("margin-right", halfWindowWidth - $(this).offset().left + 'px');
          } else{
            $(this).css("margin-right", xRightPosDeg +"px");
          }
        }
      });
    }

    function scrollTopPos(divName, yPosDeg) {
      $(divName).each(function(){

        if(halfWindowWidth >= $(this).offset().left){
          if ((halfWindowWidth - $(this).offset().left) <= yPosDeg ) {
            $(this).css("margin-top", halfWindowWidth - $(this).offset().left + 'px');
          } else{
            $(this).css("margin-top", yPosDeg +"px");
          }
        }
      });
    }

    function scrollpaddingTopPos(divName, pTopPosDeg) {
      $(divName).each(function(){

        if(halfWindowWidth >= $(this).offset().left){
          if ((halfWindowWidth - $(this).offset().left) <= pTopPosDeg ) {
            $(this).css("padding-top", halfWindowWidth - $(this).offset().left + 'px');
          } else{
            $(this).css("padding-top", pTopPosDeg +"px");
          }
        }
      });
    }
    if($(".services-container").is(":visible")){
      scrollContainer.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        if($(window).width() >= 992){
          scrollContainer.scrollLeft += evt.deltaY * 1;
          scrollLeftPos(".sh-anim-right","250");
          // scrollLeftPos(".shp-container-anim-set","300");
          scrollTopPos(".shp-anim1","200");
          scrollAddClass(".shp-anim2","active");
          scrollAddClass(".shp-anim3","active");
          scrollLeftPos(".cms-line.wid3","200");
          // scrollLeftPos(".silotainer-anim1","200");
          scrollAddClass(".cms-silotainer-anim","active");
          scrollAddClass(".silotainer-anim2","active");
          // scrollLeftPos(".silotainer-anim3","200");
          // scrollAddClass(".sh.color1.width2","active");
          scrollAddClass(".silotainer-anim3","active");
          scrollVideo("#vid","active");
          scrollLeftPos(".cms-transportation-img-anim","200");
          scrollTopPos(".transportation-img2","200");
          scrollLeftPos(".cms-line.wid5","200");
          scrollAddClass(".cms-storage-img-anim","active");
          // scrollLeftPos(".storage-img1","440");
          // scrollRightPos(".storage-img2","420");
          scrollLeftPos(".cms-overland-anim","500");
          // scrollAddClass(".cms-air-anim-video .sh","active");
          scrollAddClass(".transportation-anim-img1","active");
          scrollAddClass(".transportation-anim-img2","active");
          scrollVideo("#vid2","active");
          scrollAddClass(".cms-anim-video-item","active");
          scrollVideo("#vid4","active"); 
        } else{
          const vid = document.querySelectorAll("video");
          for (var i = 0; i < $("video").length; i++) {
            const j = i; // Create local copy
            vid[j].autoplay = "autoplay";
            vid[j].muted = true;  
            vid[j].play();
          }
        }
        // $(".scroll-pos").each(function(){
        //   if(halfWindowWidth >= $(this).offset().left){
        //     console.log($(this).offset().left);
        //     $(this).addClass("active");
        //   } else if($(this).offset().left <= $(this).width()){
        //     $(this).removeClass("active");
        //   }
        // });
          
      });
    }

    // gsap.registerPlugin(ScrollTrigger);

  //   let sectionsWrapper = gsap.utils.toArray(".services-container"),
  //       sections = gsap.utils.toArray(".cms");

  //   let scrollTween = gsap.to(sections, {
  //     xPercent: -100 * (sections.length - 1),
  //     ease: "none", // <-- IMPORTANT!
  //     scrollTrigger: {
  //       trigger: ".services-container",
  //       start: "top left",
  //       pin: true,
  //       scrub: 1,
  //       //snap: directionalSnap(1 / (sections.length - 1)),
  //       invalidateOnRefresh: true,
  //       end: "+=7000", 
  //     }
  //   });

  // gsap.set(".cms-line.wid1", {x: 0});
  // gsap.set(".shp-anim1", {y: 0});



  // gsap.to(".cms-line.wid1", {
  //   x: -400,
  //   ease: "slow",
  //   scrollTrigger: {
  //     trigger: ".cms-line.wid1",
  //     containerAnimation: scrollTween,
  //     start: "0% center",
  //     end: "center 10%",
  //     scrub: true,
  //     id: "1"
  //   }
  // });


  // gsap.to(".sh-anim-right", {
  //   x: 373,
  //   ease: "slow",
  //   scrollTrigger: {
  //     trigger: ".sh-anim-right",
  //     containerAnimation: scrollTween,
  //     start: "0% center",
  //     end: "center 10%",
  //     scrub: true,
  //     id: "2"
  //   }
  // });


  // gsap.to(".shp-anim1", {
  //   y: 210,
  //   ease: "slow",
  //   scrollTrigger: {
  //     trigger: ".shp-anim1",
  //     containerAnimation: scrollTween,
  //     start: "-100% center",
  //     end: "center 0%",
  //     scrub: true,
  //     id: "3"
  //   }
  // });
  


  // helper function for causing the sections to always snap in the direction of the scroll (next section) rather than whichever section is "closest" when scrolling stops.
  // function directionalSnap(increment) {
  //   let snapFunc = gsap.utils.snap(increment);
  //   return (raw, self) => {
  //     let n = snapFunc(raw);
  //     return Math.abs(n - raw) < 1e-4 || (n < raw) === self.direction < 0 ? n : self.direction < 0 ? n - increment : n + increment;
  //   };
  // }

  // making the code pretty/formatted.
  // PR.prettyPrint();
  };

  const init = () => {
    defaultTab2();
  };

  return {
    init,
  };
})();

export default scrollAnimation;
